<template>
   
</template>

<script>
export default {

}
</script>

<style scoped>
.part3_1_main_box{
    margin-top: 40px;
}
.part3_1_main_box .main_title{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
}
.part3_1_main_box .main_jie{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    margin-top: 15px;
}
.page_shadow .part3_1_main_box .main_norm_box{
    background: url("../../../../../public/imgs/cepingreport/page_4_1.png") no-repeat 50%;
    background-size: 100% 100%;
    margin-top: 30px;
}
.page_shadow .main_norm_box{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 10px 0 10px;
    width: 712px;
    height: 60px;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-bottom: 20px;
}
.page_shadow .part3_1_main_box .main_norm_box .norm_box{
    background-color: #f6a724;
}
.page_shadow .main_norm_box .norm_box{
    width: 692px;
    height: 18px;
    background-color: #1ca4b6;
    position: relative;
    border-radius: 10px;
}
.page_shadow .part3_1_main_box .main_norm_box .norm_box .norm_score{
    border-right: 1px dotted #f6a724;
}
.page_shadow .main_norm_box .norm_box .norm_score{
    position: absolute;
    right: 0;
    top: -11px;
    width: 0;
    height: 40px;
    border-right: 1px dotted #1ca4b6;
}
.page_shadow .part3_1_main_box .main_norm_box .norm_box .score{
    background-color: #f6a724;
}
.page_shadow .main_norm_box .norm_box .norm_score .score{
    width: 46px;
    height: 20px;
    line-height: 20px;
    background-color: #1ca4b6;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 3px;
    position: absolute;
    left: -22.5px;
    top: -30px;
}
.page_shadow .part3_1_main_box .main_norm_box .norm_box .norm_block {
    background-color: rgba(121,119,119,.49);
}
.page_shadow .main_norm_box .norm_box .norm_block{
    height: 26px;
    position: absolute;
    top: -4px;
    background-color: rgba(121,119,119,.49);
}
.page_shadow .main_detail{
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 22px;
}
.page_shadow .main_detail span{
    margin-left: 15px;
    font-size: 16px;
}
.page_shadow .color2{
    color: #ffc001;
}
.page_shadow .main_detail span{
    font-size: 16px;
}
.page_shadow .color1{
    color: red;
}
.part3_1_main_box .main_directions{
    padding: 15px;
    font-size: 14px;
    color: #000;
    font-weight: 600;
    line-height: 28px;
    background-color: #f7f7f7;
    border-radius: 5px;
}
.part3_1_main_box .main_directions span{
    font-size: 14px;
    font-weight: 400;
    color: #969696;
    line-height: 29px;
}
</style>